import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface DepartmentTab {
  id: string;
  label: string;
}

interface FactItem {
  title: string;
  value: string;
}

interface OutcomeItem {
  title: string;
  description: string;
}

interface LabItem {
  title: string;
  image: string;
  description: string;
}

interface ProgrammeItem {
  sno: number;
  name: string;
  duration: string;
}

interface ActivityItem {
  sno: number;
  activity: string;
  date: string;
  description: string;
}

interface MouItem {
  sno: number;
  organization: string;
  date: string;
  purpose: string;
}
interface PlacementItem {
  sno: number;
  batch: string;
  studentName: string;
  designation: string;
  companyName: string;
}

interface IndustrialVisitItem {
  title: string;
  image: string;
  description: string;
}

interface ValueAddedCourseItem {
  sno: number;
  courseName: string;
  courseDetails: string;
  commenceDate: string;
}

interface AlumniItem {
  name: string;
  batch: string;
  role: string;
  company: string;
  quote: string;
  image: string;
}

interface AchievementItem {
  title: string;
  image: string;
  description: string;
}

interface NptelRecordItem {
  courseName: string;
  staffName: string;
  subject: string;
  grade: string;
  session: string;
}

interface ConferenceItem {
  sno: number;
  conferenceName: string;
  paperTitle: string;
  authors: string[];
  collegeName: string;
  date: string;
}

interface PatentItem {
  sno: number;
  academicYear: string;
  name: string;
  category: string;
  inventionTitle: string;
  applicationNumber: string;
  publicationDate: string;
  status: string;
}
interface JournalPublicationItem {
  sno: number;
  event: string;
  authors: string[];
  date: string;
  journalName: string;
  title: string;
}

@Component({
  selector: 'app-pricing-page',
  templateUrl: './pricing-page.component.html',
  styleUrls: ['./pricing-page.component.scss']
})
export class PricingPageComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  departmentName = 'Department of Electrical & Electronics Engineering';
  establishedYear = '2011';
  intake = '60 Students';
  programmeSummary = '1 UG + 1 PG Programme';
  contactEmail = 'hodeee@fmcet.ac.in';

 admissionNotice =
    'Admissions open for 2026 : B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - CS),B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA,M.E. (CSE), M.E. (Embedded System Technologies),M.E. (Thermal Engineering), M.E. (Environmental Engineering)';
      
  tabs: DepartmentTab[] = [
    { id: 'tab1', label: 'About the Department' },
    { id: 'tab2', label: 'Vision & Mission' },
    { id: 'tab3', label: "PEO's" },
    { id: 'tab4', label: 'POs & PSOs' },
    { id: 'tab14', label: 'Programme Offered' },
    { id: 'tab5', label: 'Laboratory Facilities' },
    { id: 'tab6', label: 'Association Activities' },
    { id: 'tab7', label: "MoU's" },
    { id: 'tab8', label: 'Placement Record' },
    { id: 'tab9', label: 'Industrial Visit' },
    { id: 'tab10', label: 'Value Added Courses' },
    { id: 'tab11', label: 'Alumni' },
    { id: 'tab12', label: 'Achievements' },
    { id: 'tab13', label: 'NPTEL' },
    { id: 'tab15', label: 'Research' }
  ];

  aboutParagraphs: string[] = [
    'The Department of Electrical & Electronics Engineering was established in the year 2011 with an intake of 60 students approved by AICTE. The department accommodates Outcome Based Education, which helps students to learn, develop, and serve society.',
    'The department has experienced and dedicated faculty with a wide range of specializations including Power System, Power Electronics, and Embedded Systems. It has well established laboratory facilities to conduct research work in specialized areas like Renewable Energy, Power Quality, and Power Electronics.',
    'Students of the department have received external research funding from the Tamil Nadu State Council for Science and Technology in recent years. Students have also joined reputed industries through placements, and some have become entrepreneurs. The department has a good alumni network.',
    'The Training and Placement Cell is an integral part of the department. Training activities are organized throughout the year to prepare students for campus recruitment, while maintaining continuous communication regarding placement opportunities.'
  ];

  quickFacts: FactItem[] = [
    {
      title: 'Established',
      value: '2011'
    },
    {
      title: 'Intake',
      value: '60 Students'
    },
    {
      title: 'Academic Focus',
      value: 'Power Systems, Power Electronics, Embedded Systems, Renewable Energy, and Power Quality'
    },
    {
      title: 'Department Strength',
      value: 'Outcome-based education, research support, placements, entrepreneurship, and strong alumni network'
    }
  ];

  visionText =
    'The Department of Electrical and Electronics Engineering is providing programs of the highest quality to produce globally competent technocrats who can address the challenges of the millennium and achieve sustainable socio-economic development.';

  missionPoints: string[] = [
    'To create graduates possessing sound fundamental knowledge of Electrical Engineering.',
    'To provide technocrats for industry.',
    'To pursue research in Electrical & Electronics Engineering and across disciplines.'
  ];

  peos: string[] = [
    'Find employment in core Electrical and Electronics Engineering and service sectors.',
    'Get elevated to technical lead positions and lead organizations competitively.',
    'Enter into higher studies leading to postgraduate and research degrees.',
    'Become consultants and provide solutions to practical problems of core organizations. Become entrepreneurs and be part of electrical and electronics product and service industries.'
  ];

  programOutcomes: OutcomeItem[] = [
    {
      title: 'Engineering Knowledge',
      description:
        'Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.'
    },
    {
      title: 'Problem Analysis',
      description:
        'Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using first principles of mathematics, natural sciences, and engineering sciences.'
    },
    {
      title: 'Design / Development of Solutions',
      description:
        'Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for public health, safety, cultural, societal, and environmental considerations.'
    },
    {
      title: 'Conduct Investigations of Complex Problems',
      description:
        'Use research-based knowledge and research methods including design of experiments, analysis and interpretation of data, and synthesis of information to provide valid conclusions.'
    },
    {
      title: 'Modern Tool Usage',
      description:
        'Create, select, and apply appropriate techniques, resources, and modern engineering and IT tools including prediction and modeling to complex engineering activities with an understanding of the limitations.'
    },
    {
      title: 'The Engineer and Society',
      description:
        'Apply reasoning informed by contextual knowledge to assess societal, health, safety, legal, and cultural issues and the consequent responsibilities relevant to professional engineering practice.'
    },
    {
      title: 'Environment and Sustainability',
      description:
        'Understand the impact of professional engineering solutions in societal and environmental contexts, and demonstrate the knowledge of and need for sustainable development.'
    },
    {
      title: 'Ethics',
      description:
        'Apply ethical principles and commit to professional ethics, responsibilities, and norms of engineering practice.'
    },
    {
      title: 'Individual and Teamwork',
      description:
        'Function effectively as an individual, and as a member or leader in diverse teams and multidisciplinary settings.'
    },
    {
      title: 'Communication',
      description:
        'Communicate effectively on complex engineering activities with the engineering community and society at large through effective reports, design documentation, presentations, and clear instructions.'
    },
    {
      title: 'Project Management and Finance',
      description:
        'Demonstrate knowledge and understanding of engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.'
    },
    {
      title: 'Life-long Learning',
      description:
        'Recognize the need for, and have the preparation and ability to engage in independent and life-long learning in the broadest context of technological change.'
    }
  ];

  programSpecificOutcomes: OutcomeItem[] = [
    {
      title: 'Foundation of Electrical Engineering',
      description:
        'Understand the principles and working of electrical components, circuits, systems, and control that form a part of power generation, transmission, distribution, utilization, conservation, and energy saving. Students can assess power management, auditing, crisis, and energy saving aspects.'
    },
    {
      title: 'Foundation of Mathematical Concepts',
      description:
        'Apply mathematical methodologies to solve problems related to Electrical Engineering using appropriate engineering tools and algorithms.'
    },
    {
      title: 'Computing and Research Ability',
      description:
        'Use knowledge in various domains to identify research gaps and provide solutions that lead to new ideas and innovations.'
    }
  ];

  programmes: ProgrammeItem[] = [
    {
      sno: 1,
      name: 'B.E. Electrical & Electronics Engineering',
      duration: '4 Years'
    },
    {
      sno: 2,
      name: 'M.E. Embedded System Technologies',
      duration: '2 Years'
    }
  ];

  labs: LabItem[] = [
  {
    title: 'Power Electronics and Drives Laboratory',
    image: 'assets/img/eee/1.png',
    description:
      'The Power Electronics and Drives Laboratory focuses on designing, analyzing, and implementing power electronic converters and motor drive systems, including AC-DC, DC-DC, and DC-AC converters. It also supports research in electric vehicle drives and advanced controller implementations using FPGA and DSP platforms.'
  },
  {
    title: 'Control and Instrumentation Laboratory',
    image: 'assets/img/eee/2.png',
    description:
      'The Control and Instrumentation Laboratory provides a platform for studying and implementing control systems, measurement techniques, and simulation using sensors, transducers, signal conditioning, and data acquisition systems. It supports experimentation with classical and modern control methods, real-time analysis, and simulation tools like MATLAB/Simulink and LabVIEW for applications in industries, robotics, and smart automation.'
  },
  {
    title: 'Electrical Machines Laboratory',
    image: 'assets/img/eee/3.png',
    description:
      'The Electrical Machines Laboratory provides practical knowledge and experimental analysis of DC machines, transformers, induction motors, and synchronous machines, focusing on their construction, operation, and performance under various load conditions. It supports studies on speed control, efficiency, losses, starting methods, braking techniques, and parallel operation, bridging theory with real-time applications in electric drives, energy conversion, and industrial systems.'
  },
  {
    title: 'Power Systems Laboratory',
    image: 'assets/img/eee/4.png',
    description:
      'The Power Systems Laboratory provides practical exposure and research capabilities in power generation, transmission, and distribution, with experiments on load flow, fault analysis, stability, protection schemes, and power quality. It uses advanced tools like MATLAB/Simulink and ETAP to model and simulate complex networks, supporting research in smart grids, renewable energy integration, and efficient energy management.'
  },
  {
    title: 'Renewable Energy Laboratory',
    image: 'assets/img/eee/5.png',
    description:
      'The Renewable Energy Laboratory provides practical and research-oriented knowledge in solar PV (grid-connected and standalone), wind energy emulation, and hybrid systems with storage. It supports battery management, energy storage analysis, and simulation using MATLAB/Simulink, promoting innovation in clean energy, efficiency, and sustainable power generation.'
  },
  {
    title: 'Electric Circuits Laboratory',
    image: 'assets/img/eee/6.png',
    description:
      'The Electric Circuits Laboratory provides fundamental understanding and practical knowledge of electrical circuits through experiments on laws, theorems, AC/DC analysis, resonance, filters, and waveform studies. It uses components, measuring instruments, and simulation tools like MATLAB/Simulink to model and analyze circuits, forming the foundation for advanced electrical engineering applications.'
  },
  {
    title: 'Embedded Systems and IoT Laboratory',
    image: 'assets/img/eee/7.png',
    description:
      'The Embedded Systems and IoT Laboratory provides a platform for designing and developing intelligent embedded and connected systems using boards like Arduino, Raspberry Pi, ARM controllers, sensors, actuators, and communication modules. It supports real-time applications, IoT solutions, wireless technologies, cloud integration, and data analytics, fostering innovation in smart homes, automation, healthcare, and precision agriculture.'
  }
];

associationActivities: ActivityItem[] = [
  {
    sno: 1,
    activity: 'Saturday Online Club Activity Seminar Presentation on Hydro Power Plant',
    date: '21.03.2026',
    description:
      'An online Saturday club seminar presentation exploring the design, operation, and significance of hydro power plants.'
  },
  {
    sno: 2,
    activity: 'Workshop on "Electronics Measurements and Basic Service"',
    date: '11.02.2026',
    description:
      'An engaging workshop providing hands-on knowledge of electronic measurements and basic servicing techniques.'
  },
  {
    sno: 3,
    activity: 'Energy Saving Club Students Online Activity Seminar Presentation on Application of FACTS Devices in Power System',
    date: '07.02.2026',
    description:
      'An online energy saving club seminar presentation on the applications of FACTS devices for enhancing power system performance.'
  },
  {
    sno: 4,
    activity: 'Industrial Interaction on "Industrial Automation and Control System"',
    date: '30.01.2026',
    description:
      'An industrial interaction session focusing on advancements in automation and control systems for modern industries.'
  },
  {
    sno: 5,
    activity: 'Seminar on "The Power of Innovation: Shaping and Driving the Future of Electrical Technology"',
    date: '28.01.2026',
    description:
      'An inspiring seminar on harnessing innovation to shape and drive the future of electrical technology.'
  },
  {
    sno: 6,
    activity: 'Seminar on "Eco-Friendly Nano-Dielectric Insulation Materials: A Cutting-Edge Paradigm in High Voltage Engineering"',
    date: '09.01.2026',
    description:
      'An advanced seminar showcasing eco-friendly nano-dielectric insulation materials as a breakthrough in high voltage engineering.'
  },
  {
    sno: 7,
    activity: 'Seminar on "Project Design"',
    date: '07.01.2026',
    description:
      'An insightful seminar focused on principles and practices of effective project design for engineering and industry.'
  },
  {
    sno: 8,
    activity: 'Online Webinar on "Recent Trends in Electrical Engineering"',
    date: '28.10.2025',
    description:
      'An online webinar highlighting emerging technologies and recent advancements shaping the field of electrical engineering.'
  },
  {
    sno: 9,
    activity: 'AICTE Sponsored 12 Days ATAL FDP on "Renewable Energy Based Electric Vehicle Battery Management System With AI for Sustainable Transportation"',
    date: '15.09.2025 to 27.09.2025',
    description:
      'An AICTE-sponsored 12-day ATAL FDP focusing on AI-driven battery management systems for renewable energy-based electric vehicles to promote sustainable transportation.'
  },
  {
    sno: 10,
    activity: 'Energy Club Online Activity Seminar Presentation on Distribution System and Job Opportunities',
    date: '13.09.2025',
    description:
      'An online energy club seminar presentation exploring distribution systems and related job opportunities in the power sector.'
  },
  {
    sno: 11,
    activity: 'Seminar on "Renewable Energy"',
    date: '09.09.2025',
    description:
      'An informative seminar exploring sustainable technologies and innovations driving the future of renewable energy.'
  },
  {
    sno: 12,
    activity: 'Energy Club Online Activity Seminar Presentation on Distribution System',
    date: '06.09.2025',
    description:
      'An online energy club seminar presentation discussing the structure, operation, and importance of power distribution systems.'
  },
  {
    sno: 13,
    activity: 'Alumni Interaction Session',
    date: '25.08.2025 (AN)',
    description:
      'An interactive session fostering connections between alumni and students through shared experiences and guidance.'
  },
  {
    sno: 14,
    activity: 'Seminar on "Building Industry-Ready Engineers"',
    date: '25.08.2025 (FN)',
    description:
      'An engaging seminar focused on equipping engineers with practical skills and competencies to meet industry demands.'
  },
  {
    sno: 15,
    activity: 'Electric Studio Club Online Activity on Delta PLC Programming',
    date: '23.08.2025',
    description:
      'An online electric studio club activity focused on practical learning of Delta PLC programming techniques.'
  },
  {
    sno: 16,
    activity: 'Industry Expert Talk on "AI Based Solution For Industries"',
    date: '21.08.2025',
    description:
      'An expert talk highlighting AI-driven solutions that transform industrial processes, efficiency, and innovation.'
  },
  {
    sno: 17,
    activity: 'Seminar on "Machine Learning Techniques"',
    date: '13.08.2025',
    description:
      'An insightful seminar exploring core machine learning techniques, algorithms, and their real-world applications.'
  },
  {
    sno: 18,
    activity: 'Electric Studio Club Online Activity Seminar Presentation on Power Stations in India',
    date: '09.08.2025',
    description:
      'An online electric studio club seminar presentation highlighting the role and significance of power stations in India.'
  },
  {
    sno: 19,
    activity: 'E Vehicle Technologies',
    date: '19.03.2025',
    description:
      'Electric Vehicle Technologies refer to systems and innovations that enable vehicles to run on electric power using batteries, motors, and power electronics instead of conventional fuel engines.'
  },
  {
    sno: 20,
    activity: 'How to Start a Research - An Experience Sharing',
    date: '08.01.2025',
    description:
      'Start a research experience sharing by briefly introducing the topic, purpose, and key learning or insight gained from your study.'
  }
];

  mous: MouItem[] = [
    {
      sno: 1,
      organization: 'VIRTUAL TECHNOLOGY',
      date: '22.11.2021',
      purpose: 'Partnership for skill training.'
    },
    {
      sno: 2,
      organization: 'WISE TECH SOURCE PVT, LTD',
      date: '28.10.2021',
      purpose: 'Collaboration on student exchange programs.'
    },
    {
      sno: 3,
      organization: 'SMART MAKERS',
      date: '06.03.2021',
      purpose:
        'Partnership for skill training, special lectures on emerging technology, and industry-based project development skills.'
    },
    {
      sno: 4,
      organization: 'LIVE WIRE TECHNOLOGIES',
      date: '08.01.2019',
      purpose:
        'Collaboration on research projects and student exchange programs.'
    },
    {
  sno: 5,
  organization: 'Madurai SM Techno Park Pvt. Ltd.',
  date: '25.02.2025',
  purpose:
    'Partnership for skill training, special lectures on emerging technology, and industry-based project development skills.'
},
{
  sno: 6,
  organization: 'Vaibavsri Solution Pvt. Ltd., Madurai',
  date: '25.08.2025',
  purpose:
    'Collaboration on student exchange programs.'
}
  ];

placementRecords: PlacementItem[] = [

  {
    sno: 1,
    batch: '2022-2026',
    studentName: 'AASHIKAHAMED A',
    designation: 'Technical Support',
    companyName: 'Madura Solution'
  },
  {
    sno: 2,
    batch: '2022-2026',
    studentName: 'ALAGESWARAN S',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },

  {
    sno: 3,
    batch: '2022-2026',
    studentName: 'CHANDRU N R',
    designation: 'Business Development Associate',
    companyName: 'Besant Campus Connect'
  },
  {
    sno: 4,
    batch: '2022-2026',
    studentName: 'GIRIJA M',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },
  {
    sno: 5,
    batch: '2022-2026',
    studentName: 'GOWSALYA',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },
  {
    sno: 6,
    batch: '2022-2026',
    studentName: 'HARIHARAN S',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },
  {
    sno: 7,
    batch: '2022-2026',
    studentName: 'HARINI R',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },
  {
    sno: 8,
    batch: '2022-2026',
    studentName: 'HARINI R',
    designation: 'Electrical Draft Woman',
    companyName: 'Gulf Engineering'
  },
  {
    sno: 9,
    batch: '2022-2026',
    studentName: 'JEYA SURYA M',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },

  {
    sno: 10,
    batch: '2022-2026',
    studentName: 'KANIMOZHI K',
    designation: 'Business Development Associate',
    companyName: 'Prime Vector'
  },
  {
    sno: 11,
    batch: '2022-2026',
    studentName: 'KESAVAN G',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },
  {
    sno: 12,
    batch: '2022-2026',
    studentName: 'MADESH B',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },
  {
    sno: 13,
    batch: '2022-2026',
    studentName: 'MAHALAKSHMI P',
    designation: 'Business Development Associate',
    companyName: 'Prime Vector'
  },
  {
    sno: 14,
    batch: '2022-2026',
    studentName: 'MUKESHWARAN M',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },

  {
    sno: 15,
    batch: '2022-2026',
    studentName: 'RAMANATHAN C',
    designation: 'Trainee',
    companyName: 'Besant Campus Connect'
  },

  {
    sno: 16,
    batch: '2022-2026',
    studentName: 'SANTHIYA K',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },

  {
    sno: 17,
    batch: '2022-2026',
    studentName: 'YOGESHWARAN T K',
    designation: 'Business Development Associate',
    companyName: 'Prime Vector'
  },
  {
    sno: 18,
    batch: '2022-2026',
    studentName: 'YUVARAJ R',
    designation: 'Trainee',
    companyName: 'Delphi TVS'
  },
  {
    sno: 19,
batch: '2021-2025',
    studentName: 'Barathkumar .P',
    designation: 'Junior Software Developer',
    companyName: 'Qspider, Chennai'
  },
  {
    sno: 20,
batch: '2021-2025',
    studentName: 'Selvaganesh .P',
    designation: 'Data Analyst',
    companyName: 'Qspider, Chennai'
  },
  {
    sno: 21,
batch: '2021-2025',
    studentName: 'Mathanagopal .P',
    designation: 'Site Engineer',
    companyName: 'Tcon Engineering PVT LTD'
  },
  {
    sno: 22,
  batch: '2019-2023',
    studentName: 'Hemanth Kumar .S',
    designation: 'Maintenance Engineer',
    companyName: 'Team Engineers, Chennai'
  },
  {
    sno: 23,
    batch: '2019-2023',
    studentName: 'Kandeepan .C',
    designation: 'Electrical Supervisor',
    companyName: 'RS Architects And Construction, Sivagangai'
  },
  {
    sno: 24,
    batch: '2019-2023',
    studentName: 'Sangeetha .V',
    designation: 'Production Support Engineer',
    companyName: 'V. Ilango Engineering Contractor, Madurai'
  },
  {
    sno: 25,
    batch: '2019-2023',
    studentName: 'Sobika .M',
    designation: 'Assistant Engineer',
    companyName: 'Threads N Needles, Madurai'
  },
  {
    sno: 26,
    batch: '2019-2023',
    studentName: 'Vigneshwaran .M',
    designation: 'Electrical Site Engineer',
    companyName: 'RS Architects And Construction, Sivagangai'
  },
  {
    sno: 27,
    batch: '2019-2023',
    studentName: 'Sivasankar K',
    designation: 'Maintenance Engineer',
    companyName: 'RS Architects And Construction, Sivagangai'
  },
  {
    sno: 28,
    batch: '2019-2023',
    studentName: 'Pushpalatha D',
    designation: 'Design Engineer',
    companyName: 'Team Engineers, Chennai'
  }
];

  industrialVisits: IndustrialVisitItem[] = [
    {
      title: 'Visit to Jothi Electrical Industry',
      image: 'assets/img/eee/iv1.jpg',
      description:
        'Students visited Jothi Electrical Industries to gain real-world insight into the electrical industry, especially products and services related to transformers and electrical motors.'
    },
    {
      title: 'Visit to STK Transformers',
      image: 'assets/img/eee/iv2.jpg',
      description:
        'Students visited STK Transformers to understand the manufacture of distribution transformers, welding transformers, ballasts, and other electrical apparatus.'
    },
    {
      title: 'Visit to Kudankulam Nuclear Power Plant',
      image: 'assets/img/eee/iv3.jpg',
      description:
        'Students visited Kudankulam Nuclear Power Plant and observed reactor units, generators, cooling systems, and safety measures related to nuclear power generation.'
    },
    {
      title: 'Visit to MEDC / METRO',
      image: 'assets/img/eee/iv4.jpg',
      description:
        'Students visited a major substation to learn about power distribution systems, indoor and outdoor units, and SCADA and RTU-based monitoring systems.'
    }
  ];

  valueAddedCourses: ValueAddedCourseItem[] = [
    {
      sno: 1,
      courseName: 'Electric Safety Training Program',
      courseDetails:
        'Emphasizing the importance of electrical safety, encouraging active participation in safety initiatives, and promoting awareness about hazards and incidents.',
      commenceDate: '03.09.2024'
    },
{
  sno: 2,
  courseName: 'Arduino & IOT- EEAI25',
  courseDetails:
    'A hands-on value added course conducted by Hi-Tech Academy, Madurai, focusing on Arduino programming, sensor interfacing, embedded system basics, and IoT application development for real-time monitoring and automation.',
  commenceDate: '06.01.2025'
},
{
  sno: 3,
  courseName: 'Drone Technologies',
  courseDetails:
    'A skill-oriented programme conducted by Hi-Tech Academy, Madurai, introducing students to drone components, flight control systems, embedded electronics, communication modules, and practical applications of drone technology in industry and research.',
  commenceDate: '02.02.2026'
}
  ];

  alumniRecords: AlumniItem[] = [
    {
      name: 'Er. V. Alagarsamy',
      batch: '2011-2015',
      role: 'Sr. Automation Engineer',
      company: 'Promho Engineering Pvt. Ltd, Chennai',
      quote:
        'The journey at this institution laid the foundation for my professional success and personal growth.',
      image: 'assets/img/eee/a1.jpeg'
    },
    {
      name: 'Er. B. Lilil Kannan',
      batch: '2017-2021',
      role: 'Testing Engineer',
      company: 'Voltech Engineering Pvt Ltd, Chennai',
      quote:
        'The journey at this institution laid the foundation for my professional success and personal growth.',
      image: 'assets/img/eee/a2.jpeg'
    },
    {
      name: 'Er. G. Anupriya',
      batch: '2018-2022',
      role: 'Design Eng',
      company: 'Caliber Interconnect Solutions Pvt. Ltd, Coimbatore',
      quote:
        'The journey at this institution laid the foundation for my professional success and personal growth.',
      image: 'assets/img/eee/a3.jpeg'
    }
  ];

achievements: AchievementItem[] = [
  {
    title: 'Best Teacher Award - Academic Year 2025-2026',
    image: 'assets/img/eee/ach1.jpeg',
    description:
      'Dr. R. Natarajan has been awarded the Best Teacher Award for the academic year 2025-2026. He has consistently demonstrated excellence in teaching through innovative methods, dedication, and commitment to student success. His ability to inspire, mentor, and bridge theory with practical knowledge makes him a deserving recipient of the Best Teacher Award.'
  },
  {
    title: 'Best Faculty Award - Academic Year 2025-2026',
    image: 'assets/img/eee/ach2.jpeg',
    description:
      'Mr. M. Mohamed Ajmal Khan has been awarded the Best Faculty Award for the academic year 2025-2026 from Sri Sakthi Institute of Engineering and Technology, Coimbatore. He exemplifies outstanding teaching through dedication, innovative approaches, and a strong commitment to student growth. His ability to inspire, guide, and connect theory with practice makes him a worthy recipient of this recognition.'
  },
  {
    title: 'AICTE ATAL FDP Coordinator - 2025',
    image: 'assets/img/eee/ach3.png',
    description:
      'Dr. R. Natarajan coordinated the AICTE-sponsored 12-day ATAL Faculty Development Programme on “Renewable Energy-Based Electric Vehicle Battery Management System with AI for Sustainable Transportation”, held from 15th to 27th September 2025, with a sanctioned grant of ₹6 lakhs. The programme engaged approximately 60 participants nationwide and featured expert sessions from academia and industry.'
  },
  {
    title: 'AICTE ATAL FDP Coordinator - 2023',
    image: 'assets/img/eee/ach4.png',
    description:
      'Dr. R. Natarajan served as the coordinator for the AICTE-sponsored 6-day ATAL Faculty Development Programme on “Renewable Energy-Based Electric Vehicle Technologies”, conducted from 18th to 23rd December 2023. The programme was supported by a sanctioned grant of ₹3.5 lakhs, attracted nearly 60 participants from across the country, and included insightful sessions delivered by distinguished experts from academia and industry.'
  }
];
  nptelRecords: NptelRecordItem[] = [
  {
    courseName: 'NPTEL',
    staffName: 'Dr. R. Natarajan',
    subject: 'Advanced Power Electronics & Control',
    grade: 'Elite Silver',
    session: 'Jul-Sept 2024'
  },
  {
    courseName: 'NPTEL',
    staffName: 'Mrs. M. Aishwarya',
    subject: 'Smart Grid Basics to Advanced Technologies',
    grade: 'Elite Silver',
    session: 'Jul-Oct 2024'
  },
  {
    courseName: 'NPTEL',
    staffName: 'Dr. R. Natarajan',
    subject: 'Digital Protection of Power system',
    grade: 'Elite',
    session: 'Jan-Mar 2025'
  },
  {
    courseName: 'NPTEL',
    staffName: 'Dr. R. Natarajan',
    subject: 'OBE & Accreditation',
    grade: 'Elite Silver',
    session: 'Jul-Oct 2025'
  },
  {
    courseName: 'NPTEL',
    staffName: 'Mrs. M. Aishwarya',
    subject: 'OBE & Accreditation',
    grade: 'Elite Silver',
    session: 'Jul-Oct 2025'
  },
  {
    courseName: 'NPTEL',
    staffName: 'Mr. M. Mohamed Ajmal Khan',
    subject: 'OBE & Accreditation',
    grade: 'Elite',
    session: 'Jul-Oct 2025'
  },
  {
    courseName: 'NPTEL',
    staffName: 'Mr. A. Prabu',
    subject: 'OBE & Accreditation',
    grade: 'Course completed',
    session: 'Jul-Oct 2025'
  }
];
conferenceRecords: ConferenceItem[] = [
  {
    sno: 1,
    conferenceName: 'Conference',
    paperTitle: 'Precision Bio medicine & Sustainable Smart City Development',
    authors: ['Dr. R. Natarajan, Prof/EEE'],
    collegeName: 'SRM Institute of Science & Technology',
    date: '04.09.2024'
  },
  {
    sno: 2,
    conferenceName: 'Conference',
    paperTitle: 'Hybrid CNN GRU model with residual connections for multiclass fault',
    authors: ['Ms. M. Aishwarya'],
    collegeName: 'PSYEC',
    date: '04.09.2024'
  },
  {
    sno: 3,
    conferenceName: 'Conference',
    paperTitle: 'Hybrid CNN GRU model with residual connections for multiclass fault',
    authors: ['Ms. G. Shanthini, Prof/EEE'],
    collegeName: 'PSYEC',
    date: '04.09.2024'
  },
  {
    sno: 4,
    conferenceName: 'Conference',
    paperTitle: 'Electric vehicle to vehicle Energy Transfer using on board converters',
    authors: ['Mr. A. Prabu, AP/EEE'],
    collegeName: 'PSYEC',
    date: '04.09.2024'
  },
  {
    sno: 5,
    conferenceName: 'Conference',
    paperTitle: 'Fire Fighting Robot using Arduino',
    authors: ['Ms. M. Aishwarya'],
    collegeName: 'Velammal Institute of Technology',
    date: '21.03.2025'
  },
  {
    sno: 6,
    conferenceName: 'Conference',
    paperTitle: 'Fire Fighting Robot using Arduino',
    authors: ['Dr. R. Natarajan, Prof/EEE'],
    collegeName: 'Velammal Institute of Technology',
    date: '21.03.2025'
  },
  {
    sno: 7,
    conferenceName: 'Conference',
    paperTitle: 'Fire Fighting Robot using Arduino',
    authors: ['Mr. A. Prabu, AP/EEE'],
    collegeName: 'Velammal Institute of Technology',
    date: '21.03.2025'
  }
];

journalPublications: JournalPublicationItem[] = [
  {
    sno: 1,
    event: 'Journal Publication',
    authors: ['Dr. R. Natarajan, Prof/EEE'],
    date: 'July 2024',
    journalName: 'International Journal of Scientific Development & Research',
    title: 'Accident Detection with Alert System & helmet Safety Monitoring System'
  },
  {
    sno: 2,
    event: 'Journal Publication',
    authors: ['Dr. R. Natarajan, Prof/EEE', 'Mr. A. Prabu, AP/EEE'],
    date: 'July 2025',
    journalName: 'TIJER – International Research Journal',
    title: 'Electric Vehicle-to-Vehicle Energy Transfer Using On-Board Converters'
  },
  {
    sno: 3,
    event: 'Journal Publication',
    authors: ['Dr. R. Natarajan, Prof/EEE', 'Mrs. M. Aishwarya', 'Mr. A. Prabu, AP/EEE'],
    date: 'July 2025',
    journalName: 'International Journal of Latest Technology in Engineering, Management & Applied Science (IJLTEMAS)',
    title: 'Fire Fighting Robot Using Arduino Microcontroller'
  },
  {
    sno: 4,
    event: 'Journal Publication',
    authors: ['Dr. R. Natarajan, Prof/EEE'],
    date: 'Oct 2025',
    journalName: 'International Journal of Electronics & Communication Engg (Scopus)',
    title: 'GT-SOH: A Graph Transformer Constructive Learning framework with Starfish Optimization for Accurate State of Health Battery Prediction In EV'
  }
];

patentRecords: PatentItem[] = [];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Department Profile';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  ngOnInit(): void {}
}